<template>
  <component
    :is="dialog"
    v-model="show"
    :title="title"
    :contact="contact"
    :show-duration="showDuration"
    @close="$emit('close')"
  >
    <template #buttons>
      <slot name="buttons" />
    </template>
  </component>
</template>

<script setup>
import { useDisplay } from 'vuetify'
const display = ref(useDisplay())
const show = defineModel('show', { type: Boolean })
defineProps({
  title: { type: String, required: true },
  contact: { type: [Object, null], default: null },
  showDuration: { type: Boolean, default: false }
})
defineEmits(['close'])
const dialog = computed(() => {
  if (display.value.smAndDown) {
    return resolveComponent('CallDialogMobile')
  }
  return resolveComponent('CallDialogDesktop')
})
</script>
